"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var canvas_confetti_1 = __importDefault(require("canvas-confetti"));
var DEFAULT_GLOBAL_OPTIONS = {
    resize: true,
    useWorker: false,
};
var DEFAULT_STYLE = {
    position: "fixed",
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
};
function getFinalStyle(style, className) {
    if (!style && !className) {
        return DEFAULT_STYLE;
    }
    return style;
}
function ReactCanvasConfetti(_a) {
    var style = _a.style, className = _a.className, width = _a.width, height = _a.height, globalOptions = _a.globalOptions, onInit = _a.onInit;
    var canvasRef = (0, react_1.useRef)(null);
    var confetti = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (!canvasRef.current) {
            return;
        }
        confetti.current = canvas_confetti_1.default.create(canvasRef.current, __assign(__assign({}, DEFAULT_GLOBAL_OPTIONS), globalOptions));
        onInit === null || onInit === void 0 ? void 0 : onInit({ confetti: confetti.current });
        return function () {
            var _a;
            (_a = confetti.current) === null || _a === void 0 ? void 0 : _a.reset();
        };
    }, []);
    return (react_1.default.createElement("canvas", { ref: canvasRef, style: getFinalStyle(style, className), className: className, width: width, height: height }));
}
exports.default = ReactCanvasConfetti;
